// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsibleText-cls1__c7ce60e245d02a215424{/*!*/}.CollapsibleText-cls2__aa332fb0bd9deaf7d52b{background:transparent;border:0;color:#111;font-size:14px;line-height:130%;padding:0 2px;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsibleText-cls1__c7ce60e245d02a215424",
	"cls2": "CollapsibleText-cls2__aa332fb0bd9deaf7d52b CollapsibleText-cls1__c7ce60e245d02a215424"
};
export default ___CSS_LOADER_EXPORT___;
